import {
  isUserAdminInSociety,
  translateRoles,
  userBoardMemberRoles,
} from '../helpers/society'
import { ISocietiesModel } from '../interfaces/models/societies.interfaces'

export const useUserRolesString = (
  userId: string | undefined,
  society: ISocietiesModel | undefined
): (string | string[] | null)[] => {
  let userRoles: string[] = []

  if (userId && isUserAdminInSociety(society, userId)) {
    userRoles = [...userRoles, 'admin']
  }

  const _userBoardMemberRoles = userId && userBoardMemberRoles(society, userId)
  if (_userBoardMemberRoles) {
    userRoles = [...userRoles, ..._userBoardMemberRoles]
  }

  return translateRoles(userRoles)
}
